class DrawerExplore extends HTMLElement {
  constructor() {
    super();

    this.script = this.querySelector('#CartJSON');

    if (!this.script) {
      return;
    }

    this.data = JSON.parse(this.script.textContent);

    if (this.data.items.length == 0) {
      return;
    }

    this.list = this.querySelector('.cart__upsell-products');

    this.init();

    this.addEventListener('click', (event) => {
      window._conv_q = window._conv_q || [];
      _conv_q.push(["triggerConversion", "1004101052"]);
      console.log('Convert: Suggested product added to cart');
    });
    
  }

  init() {
    const element = this;

    const skus = this.data.items
      .map((item) => {
        if (item.sku) {
          return item.sku;
        }
      })
      .filter((sku) => sku)
      .join(',');

    if (skus.length == 0) {
      this.closest('.cart__upsell').remove();
      return;
    }

    fetch(`${window.explore.endpoint.replace('{skus}', skus)}`)
      .then((response) => response.json())
      .then((response) => {
        var promises = [];

        response.forEach((item) => {
          var promise = new Promise((resolve, reject) => {
            fetch(
              `${window.routes.products}/${item.handle}?section_id=product_drawer-suggestions`
            )
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(
                  responseText,
                  'text/html'
                );
                const quickbuy = html.querySelector('drewer-component');

                resolve(quickbuy);
              });
          });

          promises.push(promise);
        });

        Promise.all(promises).then((quickbuys) => {
          this.list.innerHTML = '';

          quickbuys.forEach((quickbuy) => {
            if (quickbuy) {
              const li = document.createElement('li');
              li.appendChild(quickbuy);

              this.list.appendChild(li);
            }
          });

          //this.closest('.cart__upsell').classList.add('loaded');
        });
      });
  }
}

customElements.define('drawer-suggestions', DrawerExplore);


class SuggestedExplore extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      window._conv_q = window._conv_q || [];
      _conv_q.push(["triggerConversion", "1004101052"]);
      console.log('Convert: Suggested product added to cart');
    });
    
  }
}

customElements.define('cart-suggestion', SuggestedExplore);